<template>
  <div>
    <button
      class="button is-light"
      slot="trigger"
      v-if="
        user.personalInfo &&
        (user.personalInfo.personalId ||
          user.personalInfo.email ||
          user.personalInfo.cellphone)
      "
      @click.stop="$emit('open-user-info-modal', user)"
    >
      {{ `${user.personalInfo.name} ${user.personalInfo.surname}` }}
    </button>

    <p v-else>
      {{ user._id }}
    </p>
  </div>
</template>

<script>
export default {
  props: ["user"]
};
</script>
